import { inject, InjectionKey } from 'vue';
import { PreviewApiService } from './previewApiService';
import { DutyChangePreviewResponse } from '@/rennovation/planning-view/types/api/preview-response';

export const PREVIEW_API_KEY: InjectionKey<DutyChangePreviewResponse> = Symbol('PreviewApiService');

export function usePreviewApi(): PreviewApiService {
	const service = inject<PreviewApiService>(PREVIEW_API_KEY);
	if (!service) throw new Error('PreviewApiService not provided');
	return service;
}
